import api from "@/interceptors";
import { IApiPromise, IResponseData } from "@/interfaces/responseData";
import { Invite, UserRoute } from "../apiRoutes/routes";
import { AxiosResponse } from "axios";
import get from "lodash/get";

export const convertNotificationResponse = (
  res: AxiosResponse<IResponseData<any>, any>,
): { totalNew: number; action: any[] } => {
  const types = get(res, "data.data.types", []);
  const totalNew = get(res, "data.data.totalNew", 0);

  const action = types.flatMap(({ details, ...parent }) =>
    details.length > 0
      ? details.map((detail) => ({ ...parent, ...detail }))
      : [],
  );

  return { totalNew, action };
};

export const getNotificationList = (params: any): IApiPromise<any> =>
  api.get(Invite.getSystemActions, {
    params,
  });

export const markAllAsReadNotification = (params: any): IApiPromise<any> =>
  api.put(UserRoute.markAllAsReadNotification, {}, { params });
